export const MAX_FILE_SIZE_BYTES = 15_000_000;
export const MAX_FILES = 1;
export const ACCEPTED_FILE_TYPES = {
  'text/csv': ['.csv'],
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
};
